import { render, staticRenderFns } from "./AutocompleteResetDemo.vue?vue&type=template&id=3b45beaa&scoped=true"
import script from "./AutocompleteResetDemo.vue?vue&type=script&lang=js"
export * from "./AutocompleteResetDemo.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteResetDemo.vue?vue&type=style&index=0&id=3b45beaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b45beaa",
  null
  
)

export default component.exports